// extracted by mini-css-extract-plugin
module.exports = {"amount":"DisplayAudio_amount__23GeW","label":"DisplayAudio_label__2umZi"};